import { BrowserRouter, useLocation } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import AppRoutes from './routes/AppRoutes'
import { AuthProvider } from './contexts/AuthContext'
import Header from './components/common/Header'
import Sidebar from './components/common/Sidebar'
import HoldOnOverlay from './components/common/HoldOnOverlay'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './assets/styles/globals.scss'
import './App.css'

function AppLayout() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (location.pathname.startsWith('/embed')) {
    return (
      <div className="embed-layout">
        <AppRoutes />
        <HoldOnOverlay />
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="app-main-container">
        <Header />
        <main className={isAuthenticated ? "main-viewport with-sidebar" : "main-viewport"}>
          <AppRoutes />
        </main>
      </div>
      <HoldOnOverlay />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppLayout />
        <ToastContainer 
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App
